import { post, get } from '../http';
const common = {
    uploadPoint: params => post('/app/event/upload2.json', params),
    getwxId: params => {
        let host = window.location.host
        if (host.indexOf('localhost') > -1
            || host.indexOf('page.test') > -1) {
            return new Promise((resolve, reject) => {
                resolve({
                    status: '0',
                    result: {
                        userId: '3069860',
                        userPlatfromType: '0'
                    }
                });
            });
        }
        return post('/app/user/merge/getwxid.json', params)
    },
    getLiveThemeInfo: params => post('/app/live/detail.json', params),
    getSeriesInfo: params => post('/app/live/series/detail.json', params),
    getUserInfo: params => post('/app/user/get_info.json', params),
    knowAgree: params => post('/app/user/know/save', params),
    hintTipSave: params => post('/app/user/hint/tip/save', params),
    getWarnInfo: params => post('/app/estoppel/info', params),
    getStarShineInfo: params => post('/app/live/star/settings', params),
    savePlayduration: params => post('app/user/playduration.json', params)

}
export default common;


// WEBPACK FOOTER //
// ./src/cmtapp/request/api/common.js